import Routes from "./Routes/Routes";
import "./Translation/Config";

function App() {
  return (
    <div className="App">
      <Routes />
    </div>
  );
}

export default App;
